import { Component, ViewChild } from '@angular/core';
import { TransactionTableViewComponent } from '../../components/transaction/transaction-table-view/transaction-table-view.component';
import { TableView } from '../../components/ui/filterable-table/tableView';
import { UIHelpers } from '../../core/ui-helpers';
import { StorageService } from '../../core/storage/storageService';
import { TransactionFacade } from '../../models/transactions/transactionFacade';
import { BasePage } from '../BasePage';
import { MatDialog } from '@angular/material/dialog';
import { TransactionDialogComponent } from '../../components/transaction/transaction-dialog/transaction-dialog.component';

@Component({
  selector: 'app-transactions',
  templateUrl: './transactions.component.html',
  standalone: false,
})
export class TransactionsComponent extends BasePage {
  @ViewChild('transactionsTable') tableControl:
    | TransactionTableViewComponent
    | undefined;

  selectedMerchantId: string | undefined;

  tableOptions: any = {
    selectAction: 'none',
  };

  transaction: TransactionFacade | undefined;
  tableView: any;

  constructor(
    public storage: StorageService,
    public uiHelper: UIHelpers,
    private dialog: MatDialog
  ) {
    super();

    if (storage.getCurrentUser() != undefined) {
      this.tableOptions.userId = storage.getCurrentUser()?.id;
    }

    this.tableView = new TableView(TransactionTableViewComponent);
  }

  ngAfterViewInit() {
    this.tableControl?.setOptions(this.tableOptions);
  }

  handleTransactionSelected(transaction: TransactionFacade) {
    const dialogRef = this.dialog.open(TransactionDialogComponent, {
      width: '500px',
      data: { transaction: transaction },
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log('result', result);
    });
  }

}
